import { render, staticRenderFns } from "./ModalSendEmail.vue?vue&type=template&id=3a5c374e&"
import script from "./ModalSendEmail.vue?vue&type=script&lang=js&"
export * from "./ModalSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports